import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import heroBg from '../assets/images/HeroBanner.png';
import memberImage from '../assets/images/aiotaman.png';
import '../styles/EDCCMembers.css';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Mail, Phone } from 'lucide-react';
import '../styles/ExecutiveMembersAiota.css'; 

const EDCCMembers = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [Edcc, setEdcc] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleMemberLogin = () => {
    navigate('/member-login');
  };

  const handleEdcclogin = () => {
    navigate('/edcc-login');
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState){
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // Fetch EDCC members from backend
  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASEURL}/get-all-edcc-membersCMS`
        );
        if (!response.ok) {
          throw new Error('Failed to fetch members');
        }
        const result = await response.json();

        // Ensure we always get an array
        const membersArray = Array.isArray(result) ? result : result.data || [];

        // Filter active and not deleted
        const activeMembers = membersArray.filter(
          (m) => m.status === 1 && !m.isDeleted
        );

        setEdcc(activeMembers);
      } catch (error) {
        console.error('Error fetching EDCC members:', error);
        setEdcc([]); // fallback
      } finally {
        setLoading(false);
      }
    };

    fetchMembers();
  }, []);

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
              {!tokenState && (
                <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
              )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="executive-section">
            <Container>
              <h2 className="executive-title">
                ERGONOMIC DESIGN CERTIFICATION COMMITTEE MEMBERS<br />
              </h2>
            {loading ? (
  <p className="text-center">Loading members...</p>
) : Edcc.length > 0 ? (
  <Row className="five-per-row">
    {Edcc.map((member, index) => (
      <Col
        lg={3}
        md={4}
        sm={6}
        xs={12}
        key={member._id || index}
        className="member-col"
      >
        <div className="member-card-aiota-exec">
          <img
            src={member.file_url || memberImage}
            alt={member.name}
          />
          {(member.address ||
            member.mobile ||
            member.personal_mobile ||
            member.official_email) && (
            <div className="overlay">
              {member.address && (
                <p>
                  <BookOpen size={18} className='me-2' />
                  {member.address}
                </p>
              )}
              {member.mobile && (
                <p>
                  <Phone size={18} className='me-2' />
                  {member.mobile}
                </p>
              )}
              {member.personal_mobile && (
                <p>
                  <Phone size={18} className='me-2' />
                  {member.personal_mobile}
                </p>
              )}
              {member.official_email && (
                <p>
                  <Mail size={18} className='me-2' />
                  {member.official_email}
                </p>
              )}
            </div>
          )}
        </div>
        <div className="member-info-edcc-member">
          <strong>{member.name}</strong>
          <p>({member.designation})</p>
        </div>
      </Col>
    ))}
  </Row>
) : (
  <Row>
    <Col xs={12} className="text-center">
      <div className="no-data-message">
        <p className="text-muted">No EDCC members available at the moment.</p>
      </div>
    </Col>
  </Row>
)}
              
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default EDCCMembers;
